export default {
  assistant: {
    error: "Si è verificato un problema tecnico durante l'elaborazione del tuo messaggio. Per favore riprova più tardi.",
    inputPlaceholder: "Scrivi il tuo messaggio...",
    title: "Assistente IA",
    welcome: "Buongiorno! Sono il suo assistente di viaggio digitale. Sono qui per rendere il suo viaggio più piacevole aiutandola con i suoi piani e itinerari. Non esiti a inviarmi i dettagli dei suoi viaggi, non ho ancora accesso a queste informazioni. Come posso aiutarla oggi? 😊",
  },
  common: {
    save: "Salva modifiche",
    cancel: "Annulla",
    saving: "Salvataggio in corso...",
    updating: "Aggiornamento in corso...",
    back: "Indietro",
    success: "Successo",
    error: "Errore",
    deleting: "Eliminazione in corso...",
    toast: {
      success: "Successo",
      error: "Errore",
      info: "Informazione",
      warning: "Avvertimento"
    },
    in: "in"
  },
  auth: {
    signOut: "Esci",
    signOutSuccess: "Disconnessione effettuata con successo",
    redirectingHome: "Reindirizzamento alla pagina principale...",
    loginWithEmail: "Accedi con email",
    createAccount: "Crea account",
    forgotPassword: "Password dimenticata",
    forgotPasswordInstructions: "Effettua l'accesso utilizzando la tua email e poi cambia la tua password",
    firstName: "Nome",
    lastName: "Cognome",
    emailAddress: "Indirizzo email",
    passwordValidation: "La password deve contenere almeno una lettera maiuscola, una lettera minuscola, un numero, un carattere speciale e deve essere lunga tra 8 e 15 caratteri.",
    confirmEmailAddress: "Conferma indirizzo email",
    termsAgreementPart1: "Creando il tuo account, accetti i nostri",
    termsOfService: "Termini di servizio",
    privacyPolicy: "Privacy Policy",
    signUpToManageTrips: "Registrati per iniziare a gestire i tuoi viaggi",
    enterEmailForCode: "Inserisci la tua email per ricevere un codice monouso",
    verifyEmail: "Verifica email",
    noAccount: "Non hai un account? Registrati",
    signOutError: "Si è verificato un errore durante la disconnessione.",
    signOutSuccessful: "Disconnessione effettuata con successo",
    adtdTripPWaiting: "Il tuo viaggio è pronto per essere importato",
    adtdTripPWaitingDescription: "Accedi al tuo account o creane uno per procedere. Verificheremo che la prenotazione corrisponda alla tua identità.",
    loginDescription: "Monitora i voli, organizza i tuoi viaggi e accedi a tutte le tue informazioni di viaggio. Tutto ciò di cui hai bisogno per un viaggio senza intoppi, in un unico posto.",
    loginAppDescription: "Tutte le tue informazioni di viaggio in un unico posto"
  },
  sidebar: {
    assistant: "Assistente",
    myTrips: "I miei viaggi",
    newTrip: "Nuovo viaggio",
    discover: "Esplora",
    profile: "Profilo",
    feedback: "Feedback"
  },
  settings: {
    title: "Impostazioni",
    profile: {
      title: "Il mio profilo",
      firstName: "Nome",
      lastName: "Cognome",
      email: "Indirizzo email",
      country: "Paese",
      city: "Città",
      selectCountry: "Seleziona paese",
      enterCity: "Inserisci città"
    },
    language: {
      title: "Lingua",
      preferred: "Lingua preferita"
    },
    currency: {
      title: "Valuta",
      preferred: "Valuta preferita"
    },
    notifications: {
      title: "Notifiche",
      enabled: "Abilita notifiche",
      disabled: "Disabilita notifiche"
    },
    consent: {
      title: "Gestione del consenso",
      open: "Apri gestore del consenso",
      description: "Gestisci le tue preferenze di privacy e cookie"
    },
    contact: {
      title: "Contattaci",
      email: "assistenza@checkmytrip.com"
    },
    social: {
      title: "Seguici sui social media"
    },
    about: {
      title: "Informazioni",
      tos: "Termini di servizio",
      privacy: "Informativa sulla privacy",
      faq: "Domande frequenti"
    },
    deleteAccount: "Elimina account",
    deleteAccountDescription: "Elimina definitivamente il tuo account e tutti i dati associati",
    confirmDelete: "Sei sicuro?",
    deleteWarning: "Questa azione non può essere annullata. Eliminerà permanentemente il tuo account e rimuoverà tutti i tuoi dati dai nostri server.",
    confirmDeleteButton: "Sì, elimina il mio account",
    accountDeleted: "Il tuo account è stato eliminato con successo.",
    deleteError: "Impossibile eliminare l'account",
    profileUpdated: "Profilo aggiornato con successo",
    updateError: "Errore durante l'aggiornamento del profilo",
    passwordMismatch: "Le password non corrispondono",
    passwordTooShort: "La password deve contenere almeno 8 caratteri",
    passwordUpdated: "Password aggiornata con successo",
    changePassword: "Cambia password",
    newPassword: "Nuova password",
    confirmPassword: "Conferma password",
    updatePassword: "Aggiorna password",
    feedback: {
      title: "Feedback",
      description: "Apprezziamo il tuo feedback. Aiutaci a migliorare il nostro servizio condividendo i tuoi pensieri.",
      button: "Invia feedback"
    }
  },
  tripCard: {
    daysLeft: "giorni",
    flightDetails: "Dettagli del volo",
    terminal: "Terminal",
    gate: "Gate",
    checkIn: "Check-in",
    checkStatus: "Verifica stato",
    flightInfo: "Informazioni sul volo",
    airline: "Compagnia aerea",
    flight: "Volo",
    departure: "Partenza",
    arrival: "Arrivo",
    getFlightDetails: "Dettagli del volo",
    destinationInfo: "Info sulla destinazione",
    weather: "Meteo",
    activities: "Attività consigliate",
    food: "Ristoranti e caffè",
    today: "Oggi",
    dayAgo: "1 giorno fa",
    daysAgo: "{{count}} giorni fa",
    remainingDay: "1 giorno rimanente",
    remainingDays: "{{count}} giorni rimanenti",
    tripStatus: {
      ongoing: "Viaggio in corso",
      upcoming: "Viaggio imminente",
      past: "Viaggio passato"
    },
    booking: "Prenotazione",
    tripDetails: "Dettagli del viaggio",
    deleteTrip: "Elimina viaggio",
    confirmDelete: "Eliminare il viaggio?",
    deleteWarning: "Questa azione non può essere annullata. Eliminerà permanentemente il tuo viaggio a {{tripName}} e lo rimuoverà dal tuo account.",
    confirmDeleteButton: "Sì, elimina il mio viaggio",
    tripDeleted: "Il viaggio è stato eliminato con successo.",
    deleteError: "Impossibile eliminare il viaggio",
    cabinClass: "Classe cabina",
    bookingReference: "Riferimento prenotazione",
    confirmationNumbers: "Numeri di conferma",
    carRental: "Noleggio auto",
    carModel: "Modello auto",
    pickupLocation: "Luogo di ritiro",
    dropoffLocation: "Luogo di riconsegna",
    pickup: "Ritiro",
    dropoff: "Riconsegna",
    confirmationNumber: "Numero di conferma",
    addToCalendar: "Aggiungi al calendario",
    notifications: "Notifiche",
    notificationsDescription: "Notifiche importanti sui tuoi viaggi",
    noNotifications: "Nessuna notifica ancora",
    notificationsOnMobile: "Questa funzione è disponibile solo nell'app mobile al momento",
    loadingNotifications: "Caricamento notifiche...",
    taxiTransfer: "Prenota un passaggio",
    taxiTransferDesc: "Prenota un transfer in taxi per il tuo hotel o aeroporto",
    taxiTransferComingSoon: "Transfer in taxi disponibile presto",
    economy: "Economy"
  },
  newTrip: {
    title: "Aggiungi un nuovo viaggio",
    bookingReference: "Riferimento prenotazione",
    bookingReferenceDesc: "Inserisci il riferimento della prenotazione di 6 caratteri e assicurati che il nome e cognome del tuo profilo corrispondano a quelli utilizzati nella prenotazione.",
    bookingRefPlaceholder: "Riferimento (es. ABC123)",
    bookingRefTooShort: "Il riferimento della prenotazione deve contenere almeno 6 caratteri",
    bookingRefTooLong: "Il riferimento della prenotazione può contenere al massimo 10 caratteri",
    lastNamePlaceholder: "Cognome",
    findBooking: "Trova prenotazione",
    gmailSync: "Sincronizza con Gmail",
    gmailSyncDesc: "Permettici di scansionare la tua casella Gmail per le prenotazioni di viaggio",
    connectGmail: "Connetti account Gmail",
    emailForward: "Inoltra email di prenotazione",
    emailForwardDesc: "Inoltra la conferma di prenotazione per aggiungere il tuo viaggio",
    emailCopied: "Indirizzo email copiato",
    emailCopiedDesc: "L'indirizzo email è stato copiato negli appunti",
    copyEmail: "Copia indirizzo email",
    manual: "Inserimento manuale",
    manualDesc: "Aggiungi manualmente i dettagli del tuo viaggio",
    startManual: "Inizia inserimento manuale",
    bookingSubmitted: "Prenotazione inviata",
    processingBooking: "Stiamo cercando la tua prenotazione...",
    gmailConsent: "Consenso Gmail",
    gmailProcessing: "Connessione al tuo account Gmail...",
    manualEntry: "Inserimento manuale viaggio",
    manualEntryDesc: "Crea un viaggio aggiungendo autonomamente i dettagli dei voli e degli hotel",
    profileMismatch: "Spiacenti, le informazioni del tuo profilo non corrispondono alla prenotazione. Per favore, vai al Profilo e assicurati che il tuo nome e cognome siano gli stessi utilizzati per effettuare la prenotazione. Puoi anche provare a importare il tuo viaggio con le seguenti opzioni qui sotto inoltrando la tua email di conferma della prenotazione o inserendo manualmente il viaggio.",
    drawer: {
      addTripDetails: "Aggiungi dettagli viaggio",
      tripInfo: "Informazioni viaggio",
      tripName: "Nome viaggio",
      tripType: "Tipo di viaggio",
      selectTripType: "Seleziona tipo di viaggio",
      leisure: "Svago",
      business: "Lavoro",
      family: "Famiglia",
      bleisure: "Lavoro e svago",
      travelers: "Numero di viaggiatori",
      addFlight: "Aggiungi volo",
      flightNumber: "Numero volo (es. AZ1234)",
      departureDate: "Data di partenza",
      addedFlights: "Voli aggiunti",
      from: "Da:",
      to: "A:",
      terminal: "Terminal:",
      departure: "Partenza:",
      arrival: "Arrivo:",
      addHotel: "Aggiungi hotel",
      hotelName: "Nome hotel",
      cityName: "Nome città",
      selectCheckInOut: "Seleziona date check-in/check-out",
      addedHotels: "Hotel aggiunti",
      createTrip: "Crea viaggio",
      adding: "Aggiunta in corso...",
      selectFlight: "Seleziona volo",
      confirmFlight: "Conferma volo",
      step1: "Info",
      step2: "Voli",
      step3: "Hotel",
      step4: "Revisione",
      next: "Avanti",
      back: "Indietro",
      review: "Rivedi",
      flightsStepEmpty: "Aggiungi almeno un volo al tuo viaggio",
      flightsStepWithFlights: "Hai aggiunto {{count}} volo/i",
      hotelsStepEmpty: "Aggiungi hotel al tuo viaggio (opzionale)",
      hotelsStepWithHotels: "Hai aggiunto {{count}} hotel",
      reviewTrip: "Rivedi il tuo viaggio",
      reviewDescription: "Controlla i dettagli del tuo viaggio prima di crearlo",
      tripSummary: "Riepilogo viaggio",
      flightsSummary: "Voli",
      hotelsSummary: "Hotel"
    }
  },
  index: {
    greeting: "Ciao",
    greetingWithName: "Ciao, {{name}}",
    manageTrips: "Gestisci i tuoi viaggi",
    viewUpcomingFlights: "Visualizza i prossimi voli",
    errorFetchingTrips: "Assicurati di essere connesso a un account con nome ed email corrispondenti.",
    addTrip: "Aggiungi viaggio",
    importAdtdTripSuccess: "Viaggio importato con successo",
    importAdtdTripError: "Impossibile importare il viaggio in questo account",
    checkYourTrips: "Controlla i tuoi viaggi nell'app",
    welcome: {
      title: "Benvenuto nella tua app di viaggio",
      ready: "Sei pronto a gestire i tuoi viaggi in modo più intelligente?",
      features: {
        tripManagement: {
          title: "Gestione viaggi",
          description: "Organizza tutti i tuoi dettagli di viaggio in un unico posto facile da usare."
        },
        tripAlerts: {
          title: "Avvisi di viaggio",
          description: "Ricevi notifiche tempestive sui tuoi voli, cambi di gate e importanti aggiornamenti di viaggio."
        },
        inspiration: {
          title: "Ispirazione di viaggio",
          description: "Scopri nuove destinazioni e ricevi raccomandazioni personalizzate per le tue avventure"
        },
        offers: {
          title: "Offerte e sconti",
          description: "Accedi a offerte esclusive e risparmi per i tuoi prossimi viaggi."
        }
      },
      getStarted: "Consigli rapidi per iniziare",
      tips: {
        profile: "Completa il tuo profilo per un'esperienza personalizzata",
        addTrip: "Aggiungi il tuo primo viaggio facendo clic sul pulsante 'Nuovo viaggio'",
        dates: "Tieni traccia delle date importanti del viaggio nel calendario",
        notifications: "Abilita le notifiche per rimanere informato sui tuoi viaggi"
      }
    }
  },
  discover: {
    title: "Esplora",
    subtitle: "Trova attività e destinazioni da esplorare",
    getInspired: "Lasciati ispirare",
    searchFilters: "Filtri di ricerca",
    search: "Cerca",
    searchPlaceholder: "Cerca attività...",
    city: "Città",
    enterCityName: "Inserisci il nome della città",
    priceRange: "Fascia di prezzo",
    min: "Min",
    max: "Max",
    radius: "Raggio",
    enterRadius: "Inserisci raggio (km)",
    searchButton: "Cerca",
    categoryTypes: "Categorie",
    popularActivities: "Attività popolari",
    noActivitiesFound: "Nessuna attività trovata",
    tryAdjustingFilters: "Prova a modificare i filtri o a cercare in un'altra area"
  }
}
